<template>
  <el-date-picker
    v-model="local"
    type="date"
    format="DD.MM.YYYY"
    value-format="YYYY-MM-DD"
    size="large"
    @change="emitUpdate"
    class="w-full"
  />
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      local: JSON.stringify(this.item.value ?? {}, null, 2),
    };
  },
  methods: {
    emitUpdate() {
      this.$emit("update", this.item.key, this.local ? this.local : null);
    },
  },
};
</script>
